import { useWidgetsMutation } from './useWidgetsMutation';
import { useQueryClient } from '@tanstack/react-query';
export const useWidgetDeleteMutation = () => {
    const queryClient = useQueryClient();
    const { mutate, mutateAsync, ...mutation } = useWidgetsMutation();
    const filtered = (uuid) => {
        const widgets = queryClient.getQueryData(['widgets']);
        if (!widgets)
            return [];
        return widgets.filter((widget) => widget.uuid !== uuid);
    };
    return {
        ...mutation,
        mutate: (uuid, options) => mutate(filtered(uuid), options),
        mutateAsync: (uuid, options) => mutateAsync(filtered(uuid), options),
    };
};
//# sourceMappingURL=useWidgetDeleteMutation.js.map